module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/axios/index.js
// module id = 79
// module chunks = 1